import React from 'react';
import classNames from 'classnames';
import vdlPrefix from '../util/vdlPrefix';
import { omit } from 'lodash';
import { ITreeItem, MDFTreeItem } from './MDFTreeItem';
import { ILeftNavItem } from '@synerg/vdl-react-components';

export type { ITreeItem, ILeftNavItem };

export type ITreeVariant = 'flat' | 'hierarchy' | 'tree' | 'accordion';

export interface ITreeProps {
  // Root element custom CSS class
  className?: string;

  // An array of left nav item data objects
  data: ITreeItem[];

  isTree?: boolean;

  // Selected data item for the entire left nav
  selectedItem?: ITreeItem;

  // Left navigation variant
  variant?: ITreeVariant;

  // view name
  viewItem?: string;

  // Callback fired when a nav item is clicked
  onClick?: (item: ITreeItem) => void;

  // Callback fired when a nav item is expanded (expanded = true) or collapsed (expanded = false)
  onExpand: (item: ITreeItem, expanded: boolean) => void;

  // Callback fired when a nav item is selected
  onSelect?: (item: ITreeItem) => void;
}

// This array exists to make it possible to use lodash functions to filter properties.
// It's not possible to extract keys from a TypeScript interface, but we can make sure
// the array contains all the necessary keys.
const treePropsKeys = [
  'className',
  'data',
  'isTree',
  'selectedItem',
  'variant',
  'viewItem',
  'onClick',
  'onExpand',
  'onSelect'
];

export class MDFTree extends React.Component<ITreeProps, {}> {
  static defaultProps: ITreeProps = {
    variant: 'tree',
    isTree: true,
    data: [],
    onExpand: (_i, _e) => undefined
  };

  handleSelect = (item) => {
    const { onSelect } = this.props;

    if (onSelect) {
      onSelect(item);
    }
  };

  getAccordionId = (item) => {
    if (item.items) {
      return item.label.replace(/\s/g, '');
    }
  };

  render() {
    const { className, variant, data, selectedItem } = this.props;
    const customProps: any = omit(this.props, treePropsKeys);

    const rootClasses = {
      [vdlPrefix('left-nav')]: true,
      [vdlPrefix(`left-nav--${variant}`)]: true
    };

    return (
      <div
        {...customProps}
        className={classNames(className, rootClasses)}
      >
        {
          data.map((item, index) => (
            <MDFTreeItem
              key={index}
              item={item}
              onClick={this.props.onClick}
              onExpand={this.props.onExpand}
              onSelect={this.handleSelect}
              selectedItem={selectedItem}
              viewItem={this.props.viewItem}
              isTree={this.props.isTree}
              accordionId={this.getAccordionId(item)}
            >
            </MDFTreeItem>
          ))
        }
      </div>
    );
  }
}
